import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CloneEntityDialogButtonWidget: WidgetRegistryEntry = {
  name: "CloneEntityDialogButton",
  configuration: () => import("./configuration").then((m) => m.CloneEntityDialogButtonWidgetConfiguration),
  component: () =>
    import("./clone-entity-dialog-button-widget.component").then((m) => m.CloneEntityDialogButtonWidgetComponent)
};
